/**
 * WMN intent analytics — append-only event log + publish channels.
 * Exposes window.wmnIntentAnalytics (ES5-compatible).
 */
(function (window, document) {
  'use strict';

  var SID_KEY = 'wmn_sid';
  var SETTLES_KEY = 'wmn_q_settles';
  var LOG_KEY = 'wmn_intent_log_v1';
  var MAX_LOG = 500;
  var RECENT_QUERIES_MAX = 12;

  function safeParse(raw, fallback) {
    try {
      if (!raw) return fallback;
      return JSON.parse(raw);
    } catch (e) {
      return fallback;
    }
  }

  function readMeta(name) {
    try {
      var el = document.querySelector('meta[name="' + name + '"]');
      return el ? el.getAttribute('content') || '' : '';
    } catch (e) {
      return '';
    }
  }

  function getSessionId() {
    try {
      var sid = window.sessionStorage.getItem(SID_KEY);
      if (sid) return sid;
      sid =
        's' +
        Date.now().toString(36) +
        Math.random()
          .toString(36)
          .slice(2, 10);
      window.sessionStorage.setItem(SID_KEY, sid);
      return sid;
    } catch (e) {
      return 's' + Date.now().toString(36);
    }
  }

  function getCustomerId() {
    var cid = readMeta('wmn-customer-id');
    return cid || null;
  }

  function normalizeStem(q) {
    return String(q || '')
      .replace(/^\s+|\s+$/g, '')
      .toLowerCase()
      .replace(/\s+/g, ' ');
  }

  function readSettles() {
    return safeParse(
      (function () {
        try {
          return window.sessionStorage.getItem(SETTLES_KEY);
        } catch (e) {
          return null;
        }
      })(),
      {}
    );
  }

  function writeSettles(map) {
    try {
      window.sessionStorage.setItem(SETTLES_KEY, JSON.stringify(map || {}));
    } catch (e) {
      /* ignore */
    }
  }

  function getSettleCount(q) {
    var stem = normalizeStem(q);
    if (!stem) return 0;
    var map = readSettles();
    return map[stem] || 0;
  }

  function readLog() {
    var list = safeParse(
      (function () {
        try {
          return window.localStorage.getItem(LOG_KEY);
        } catch (e) {
          return null;
        }
      })(),
      []
    );
    return Array.isArray(list) ? list : [];
  }

  function writeLog(list) {
    try {
      window.localStorage.setItem(LOG_KEY, JSON.stringify(list || []));
    } catch (e) {
      /* ignore */
    }
  }

  function sliceArr(arr, max) {
    if (!arr || !arr.length) return [];
    return arr.slice(0, max);
  }

  function topEntitiesFromEngagement() {
    var out = [];
    try {
      if (
        window.wmnEngagement &&
        typeof window.wmnEngagement.getEntityPrefs === 'function'
      ) {
        var prefs = window.wmnEngagement.getEntityPrefs() || {};
        var rows = [];
        for (var k in prefs) {
          if (!Object.prototype.hasOwnProperty.call(prefs, k)) continue;
          rows.push({ id: k, w: prefs[k] || 0 });
        }
        rows.sort(function (a, b) {
          return b.w - a.w;
        });
        for (var i = 0; i < rows.length && out.length < 8; i++) {
          out.push(rows[i].id);
        }
      }
      if (
        !out.length &&
        window.wmnEngagement &&
        typeof window.wmnEngagement.getFocus === 'function'
      ) {
        var focus = window.wmnEngagement.getFocus();
        if (focus) {
          var j;
          var artists = focus.artists || [];
          var genres = focus.genres || [];
          for (j = 0; j < artists.length && out.length < 8; j++) {
            out.push('artist:' + artists[j]);
          }
          for (j = 0; j < genres.length && out.length < 8; j++) {
            out.push('genre:' + genres[j]);
          }
        }
      }
    } catch (e) {
      /* ignore */
    }
    return out;
  }

  function normalizeEvent(partial) {
    partial = partial || {};
    var type = partial.type || 'view';
    var q =
      partial.q != null && partial.q !== ''
        ? normalizeStem(partial.q)
        : null;
    var shown = Array.isArray(partial.shownHandles)
      ? sliceArr(partial.shownHandles, 12)
      : [];
    var tops = Array.isArray(partial.topEntities)
      ? sliceArr(partial.topEntities, 8)
      : topEntitiesFromEngagement();
    return {
      v: 1,
      ts: typeof partial.ts === 'number' ? partial.ts : Date.now(),
      sid: getSessionId(),
      cid: getCustomerId(),
      type: type,
      q: q,
      qSettles:
        typeof partial.qSettles === 'number'
          ? partial.qSettles
          : q
            ? getSettleCount(q)
            : null,
      mode: partial.mode != null ? String(partial.mode) : null,
      topEntities: tops,
      shownHandles: shown,
      handle: partial.handle != null ? String(partial.handle) : null,
      artist: partial.artist != null ? String(partial.artist) : null,
      dwellMs: typeof partial.dwellMs === 'number' ? partial.dwellMs : null,
      meta: partial.meta && typeof partial.meta === 'object' ? partial.meta : null
    };
  }

  function publishChannels(payload) {
    try {
      var enabled = readMeta('wmn-intent-analytics');
      if (enabled === '0') return;
    } catch (e0) {
      /* ignore */
    }

    try {
      if (
        window.Shopify &&
        window.Shopify.analytics &&
        typeof window.Shopify.analytics.publish === 'function'
      ) {
        window.Shopify.analytics.publish('wmn_intent', payload);
      }
    } catch (e1) {
      /* ignore */
    }

    try {
      if (window.dataLayer && typeof window.dataLayer.push === 'function') {
        window.dataLayer.push({
          event: 'wmn_intent',
          wmn_intent: payload
        });
      }
    } catch (e2) {
      /* ignore */
    }

    try {
      document.dispatchEvent(
        new CustomEvent('wmn:intent-event', { detail: payload })
      );
    } catch (e3) {
      /* ignore */
    }

    try {
      var beaconUrl = readMeta('wmn-intent-beacon');
      if (beaconUrl) {
        var body = JSON.stringify({ events: [payload] });
        var sent = false;
        if (
          window.navigator &&
          typeof window.navigator.sendBeacon === 'function'
        ) {
          try {
            sent = window.navigator.sendBeacon(
              beaconUrl,
              new Blob([body], { type: 'application/json' })
            );
          } catch (eb) {
            sent = false;
          }
        }
        if (!sent && typeof window.fetch === 'function') {
          window.fetch(beaconUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: body,
            keepalive: true,
            mode: 'no-cors',
            credentials: 'omit'
          }).catch(function () {});
        }
      }
    } catch (e4) {
      /* ignore */
    }
  }

  function log(partial) {
    try {
      var payload = normalizeEvent(partial);
      var list = readLog();
      list.push(payload);
      if (list.length > MAX_LOG) {
        list = list.slice(list.length - MAX_LOG);
      }
      writeLog(list);
      publishChannels(payload);
      return payload;
    } catch (e) {
      return null;
    }
  }

  function noteSearchSettle(query, extras) {
    extras = extras || {};
    var stem = normalizeStem(query);
    if (!stem) return 0;
    try {
      if (
        window.wmnQueryGuard &&
        typeof window.wmnQueryGuard.isBlocked === 'function' &&
        window.wmnQueryGuard.isBlocked(stem)
      ) {
        return 0;
      }
    } catch (eGuard) {
      /* ignore */
    }
    var map = readSettles();
    var count = (map[stem] || 0) + 1;
    map[stem] = count;
    writeSettles(map);
    var partial = {
      type: 'search_settle',
      q: stem,
      qSettles: count,
      mode: extras.mode != null ? extras.mode : null,
      shownHandles: extras.shownHandles || [],
      topEntities: extras.topEntities || null,
      meta: extras.meta || null
    };
    if (extras.handle) partial.handle = extras.handle;
    if (extras.artist) partial.artist = extras.artist;
    log(partial);
    return count;
  }

  function getLog() {
    return readLog().slice();
  }

  function exportLog() {
    try {
      return JSON.stringify(getLog());
    } catch (e) {
      return '[]';
    }
  }

  function clearLog() {
    writeLog([]);
  }

  function recentQueryStems(logList, max) {
    var seen = {};
    var out = [];
    for (var i = (logList || []).length - 1; i >= 0 && out.length < max; i--) {
      var ev = logList[i];
      if (!ev || !ev.q) continue;
      if (seen[ev.q]) continue;
      seen[ev.q] = true;
      out.push(ev.q);
    }
    return out;
  }

  function buildCloudProfile(store) {
    store = store || {};
    var settles = readSettles();
    var logList = readLog();
    var tops = topEntitiesFromEngagement();
    var interest = null;
    try {
      if (
        window.wmnEngagement &&
        typeof window.wmnEngagement.getInterestProfile === 'function'
      ) {
        interest = window.wmnEngagement.getInterestProfile();
      }
    } catch (e) {
      interest = null;
    }
    var focus = null;
    try {
      if (
        window.wmnEngagement &&
        typeof window.wmnEngagement.getFocus === 'function'
      ) {
        focus = window.wmnEngagement.getFocus();
      }
    } catch (e2) {
      focus = null;
    }
    if (!focus && interest && interest.focus) focus = interest.focus;
    var uEmb = interest && interest.uEmb ? interest.uEmb : null;
    return {
      v: 2,
      events: store.events || [],
      entities: store.entities || {},
      et: store.et,
      intent: {
        updatedAt: Date.now(),
        sid: getSessionId(),
        settles: settles,
        topEntities: tops,
        recentQueries: recentQueryStems(logList, RECENT_QUERIES_MAX),
        logTail: logList.slice(-30),
        focus: focus || undefined,
        uEmb: uEmb || undefined
      }
    };
  }

  window.wmnIntentAnalytics = {
    log: log,
    noteSearchSettle: noteSearchSettle,
    getLog: getLog,
    exportLog: exportLog,
    clearLog: clearLog,
    getSettleCount: getSettleCount,
    getSessionId: getSessionId,
    buildCloudProfile: buildCloudProfile
  };
})(window, document);
